import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import rolesTokens from "screens/Settings/RoleManagement/Roles.tokens";

const { size } = rolesTokens;

/**
 * Pager chevrons traced from the Roles design. `@mui/icons-material` ships
 * filled glyphs; the design uses a thin stroked chevron, so these are drawn
 * here with the stroke weight and size coming from the screen tokens.
 */
const PagerChevron: React.FC<SvgIconProps> = ({ children, sx, ...rest }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={size.pageArrowStrokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={{
      width: size.pageArrow,
      height: size.pageArrow,
      // SvgIcon sets `fill: currentColor`, which would beat the `fill="none"`
      // attribute and flood the outline glyph.
      fill: "none",
      ...sx,
    }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

export const PagerPrevIcon: React.FC<SvgIconProps> = (props) => (
  <PagerChevron {...props}>
    <path d="M15 18l-6-6 6-6" />
  </PagerChevron>
);

export const PagerNextIcon: React.FC<SvgIconProps> = (props) => (
  <PagerChevron {...props}>
    <path d="M9 6l6 6-6 6" />
  </PagerChevron>
);

/**
 * Form glyphs for the Create / Edit Role screen. Same stroked construction as
 * the chevrons above, so the whole screen reads as one icon set — the old
 * screen used two raster-ish SVG assets that carried their own colour.
 */
const FormGlyph: React.FC<SvgIconProps> = ({ children, sx, ...rest }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={{ fill: "none", ...sx }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

/** "Add another resource". */
export const AddResourceIcon: React.FC<SvgIconProps> = (props) => (
  <FormGlyph {...props}>
    <path d="M12 5v14M5 12h14" />
  </FormGlyph>
);

/** "Remove this resource". */
export const RemoveResourceIcon: React.FC<SvgIconProps> = (props) => (
  <FormGlyph {...props}>
    <path d="M4 7h16" />
    <path d="M10 11v6M14 11v6" />
    <path d="M6 7l1 13h10l1-13" />
    <path d="M9 7V4h6v3" />
  </FormGlyph>
);
